import Markdown from "client/common/components/content/Markdown";
import Accordion from "client/common/components/interactive/Accordion";
import Container from "client/common/components/layouts/Container";

import { IProductLineDetails } from "../types";

import styles from "../styles/ProductLineSupport.module.less";

const DividerLines = () => {
  return (
    <svg
      viewBox="0 0 1512 415"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.lines}
    >
      <path
        d="M0 1498V370.829C0 370.829 118.066 168.042 421.615 191.574C725.164 215.106 788.119 341.848 1154.62 108.264C1154.62 108.264 1283.92 10.5037 1520 14.0967V1498H0Z"
        className={styles.wave}
      />
      <path
        d="M1479.89 19.2179C1287.05 22.6455 1174.14 98.1925 1172.93 99.0611C947.178 251.566 806.588 225.746 612.051 189.953C560.456 180.462 507.049 170.64 446.212 162.686C148.873 123.758 5.31951 254.914 3.88091 256.27L7.53968 258.908C8.93026 257.593 150.954 128.118 445.358 166.654C506.097 174.611 559.357 184.394 610.904 193.886C806.811 229.897 948.331 255.902 1175.97 102.154C1177.36 101.201 1314.38 9.61416 1544.69 24.8435L1545.1 20.8424C1522.48 19.308 1500.72 18.8478 1479.89 19.2179Z"
        className={styles.line}
      />
    </svg>
  );
};

type ProductLineSupportProps = {
  productLine: IProductLineDetails;
};

const ProductLineSupport = ({ productLine }: ProductLineSupportProps) => {
  const items = productLine.support_items.map((item) => ({
    key: item.id,
    label: item.title,
    content: <Markdown markdown={item.body} hasHtml={true} />,
  }));

  if (!items.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.divider}>
        <DividerLines />
      </div>
      <div className={styles.main}>
        <Container>
          <div className={styles.faqs}>
            <div className={styles.info}>
              <div className={styles.heading}>
                <h4 className={styles.header}>
                  Frequently asked questions about{" "}
                  <span className={styles.name}>{productLine.brand_name}</span>
                </h4>
                <p className={styles.help}>(We&apos;re here to help)</p>
              </div>
              <p className={styles.disclaimer}>
                If your pet is currently prescribed {productLine.brand_name} and you have a specific
                question related to this medication, contact your veterinarian for further
                assistance.
              </p>
            </div>
            <div className={styles.content}>
              <Accordion.Single classNames={{ label: styles.label }} items={items} />
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default ProductLineSupport;
